import React from 'react';
import { useIntl } from 'react-intl';
import CheckIcon from '@material-ui/icons/Check';
import { object, arrayOf, bool, string, shape } from 'prop-types';

import { Table } from '../../components';
import { getI18n } from '../../utils/intl';

export const TiersSelect = (props) => {
    const {
      featureFlagDistributeRateLimit,
      rows,
      activeTierUuid,
      classes,
    } = props

    const { getI18nMessage } = getI18n(useIntl());
    const rateLabel = 'label.application.details.apiproducts.tiers.list.product.rate.label';
    const dLabelSecLabel = 'label.application.details.apiproducts.tiers.list.product.distribute.rate.sec';
    const dLabelMinLabel = 'label.application.details.apiproducts.tiers.list.product.distribute.rate.min';
    const emptydLabel = 'label.application.details.apiproducts.tiers.list.product.empty.distribute.rate.label';
    const emptyRateLabel = 'label.application.details.apiproducts.tiers.list.product.empty.rate.label';
    const quotaLabel = 'label.application.details.apiproducts.tiers.list.product.quota.label';
    const emptyQuotaLabel = 'label.application.details.apiproducts.tiers.list.product.empty.quota.label';
    const getListColumns = () => [{
      id: 'tierUuid',
      label: '',
      width: 16,
      format: (tierUuid) => tierUuid === activeTierUuid ? <CheckIcon className={classes.checkIcon}/> : "",
    },{
      id: 'tierName',
      label: getI18nMessage('label.application.details.apiproducts.tiers.list.tier.title'),
      width: 200,
      format: (name) => <span data-apim-test={`tier-name-${name}`} className={classes.tsTierName}>
        {name}
      </span>,
    },{
      id: 'rateQuota',
      label: getI18nMessage('label.application.details.apiproducts.tiers.list.product.title'),
      width: 600,
      format: (value = {}) => (<div>
        <div>{value.name}</div>
        {featureFlagDistributeRateLimit &&
          <div>
            {value.distributedRateLimit ? value.distributedRateLimitInterval === 'MINUTE' ?
              getI18nMessage(dLabelMinLabel, value)
             : getI18nMessage(dLabelSecLabel, value) : getI18nMessage(emptydLabel)
            }
          </div>
        }
        <div>
          {value.rateLimit ? getI18nMessage(rateLabel, value) : getI18nMessage(emptyRateLabel)}
        </div>
        <div>
          {(value.quota && value.quotaInterval) ?
            getI18nMessage(quotaLabel, value) : getI18nMessage(emptyQuotaLabel)}
        </div>
      </div>),
    }];

    return (<Table
      columns={getListColumns()}
      rows={rows}
    />);
}

TiersSelect.propTypes = {
    featureFlagDistributeRateLimit: bool,
    rows: arrayOf(object),
    activeTierUuid: string,
    classes: shape({}),
  };
  
export default TiersSelect;